import LockIcon from '@mui/icons-material/Lock';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { LockedOverlay } from '../course/CourseCard';
import { Tags } from '../course/Tags';
import { MusicSheetSVG } from '../musicsheet';
import { RoutingContext } from './context/RoutingContext';
import { RatingStars } from './elements/PracticeEvaluation/RatingStars';
export function FeaturedLessonCard({ lesson, progress, userAuthorized }) {
    const { lessonUrl } = React.useContext(RoutingContext);
    const course = lesson.course;
    return React.createElement(LessonCardStyle, { raised: false, variant: "outlined", level: lesson.tags.level ?? course?.tags.level ?? 'beginner' },
        React.createElement(CardActionArea, { href: lessonUrl(lesson) },
            React.createElement(CardContent, null,
                React.createElement(Typography, { className: "LessonName", variant: "h5", component: "h3" }, course?.name ?? lesson.name),
                course?.description && React.createElement(Typography, { className: "LessonDescription", variant: "body2" }, course.description)),
            React.createElement(ThumbnailSheet, { sheet: lesson.coverSheet, visible: userAuthorized ?? lesson.free }),
            React.createElement(Box, { className: "CardFooter" },
                React.createElement(Tags, { tags: lesson.tags }))),
        !lesson.free && !userAuthorized && React.createElement(LockedOverlay, { color: "warning" },
            React.createElement(LockIcon, null)));
}
export function LessonRatingStars({ rating }) {
    return React.createElement(LessonRatingStarsStyle, { className: "LessonRating" },
        React.createElement(RatingStars, { rating: rating, size: "small" }));
}
const LessonRatingStarsStyle = styled(Box, {
    name: 'LessonRatingStars',
    slot: 'Root'
})(({ theme }) => ({
    padding: `${theme.spacing(3)} ${theme.spacing(3)} 0 ${theme.spacing(3)}`
}));
const LessonCardStyle = styled(Card, {
    slot: 'Root',
    name: 'LessonCard',
    shouldForwardProp: (prop) => prop !== 'level'
})(({ theme, level }) => {
    const levelColor = level != null ? theme.palette.level[level] : theme.palette.augmentColor({
        color: { main: theme.palette.text.primary }
    });
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        height: '360px',
        borderRadius: '8px',
        position: 'relative',
        border: `1px solid ${levelColor.main}`,
        '& .MuiCardActionArea-root': {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'stretch',
            alignItems: 'stretch',
        },
        '& .MuiCardHeader-root .MuiTypography-h5': {
            lineHeight: 1
        },
        '& .MuiCardContent-root': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'stretch',
            alignItems: 'stretch',
            flexGrow: '1',
            padding: theme.spacing(3),
            gap: theme.spacing(1)
        },
        '& .LessonProgress': {
            flexGrow: 0,
            flexShrink: 0,
        },
        '& .LessonName': {
            flexGrow: 0,
            flexShrink: 0,
            lineHeight: 1,
            marginTop: theme.spacing(1)
        },
        '& .LessonDescription': {
            flexGrow: 1,
        },
        '& .CardFooter': {
            flexGrow: 0,
            flexShrink: 0,
            padding: `0 ${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(3)}`,
        }
    };
});
export function ThumbnailSheet({ sheet, visible }) {
    return React.createElement(ThumbnailSheetStyle, null,
        React.createElement(MusicSheetSVG, { sheet: sheet, multiVoice: false, useRepeats: false, debug: true, style: { scale: 0.7, singleline: true, stretchstaff: true, stretchlast: 1 } }));
}
const ThumbnailSheetStyle = styled(Box, { slot: 'Root', name: 'LessonSheet' })(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    overflow: 'scroll',
    '& .AbcSheet': {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
    }
}));
//# sourceMappingURL=FeaturedLessonCard.js.map